import { __decorate } from "tslib";
import { AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { CountryDecoder } from './CountryDecoder.js';
export class Province extends AutoEncoder {
    id;
    name;
    country;
}
__decorate([
    field({ decoder: StringDecoder })
], Province.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Province.prototype, "name", void 0);
__decorate([
    field({ decoder: CountryDecoder })
], Province.prototype, "country", void 0);
//# sourceMappingURL=Province.js.map